import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const header: SxStyle = {
  background: (p) => `${p.palette.common.white} !important`,
  borderBottom: (p) => `1px solid  ${p.palette.grey[300]} !important`,
};

export const label: SxStyle = {
  fontSize: (p) => `${p.typography.body4.fontSize} !important`,
  fontWeight: (p) => `${p.typography.fontWeightRegular} !important`,
  color: (p) => `${p.palette.grey[500]} !important`,
};
